/**
 * Deeply assigns values from source to target recursively.
 * Does not mutate the original target or source.
 */
export const deepAssign = (target, source) => {
    if (typeof source !== 'object' || source === null) return target;

    for (const key in source) {
        const value = source[key];
        const targetValue = target[key];
        if (typeof value === 'object' && value !== null && typeof targetValue === 'object' && targetValue !== null) {
            target[key] = deepAssign({ ...targetValue }, value);
        } else {
            target[key] = value;
        }
    }

    return target;
};
